import { BIKE_TYPES } from '../constants/bike';

export default class Shop {

    constructor(bike, color) {
        this.bike = bike;
        this.color = color;
    }

    // External link for bike shopping
    getShopURL(params) {
        console.log(params)
        const baseURL = 'https://guardianbikes.com/pages/';

        let shopURL = baseURL;

        if (Number(this.bike.wheel) === 20) {
            if (this.bike.type === BIKE_TYPES.ethos) {
                shopURL += `20-inch-small-bikes?utm_source=ridesizer&h=${this.bike.height}&c=${this.bike.color}`;
            } else if (this.bike.type === BIKE_TYPES.premium) {
                shopURL += `20-inch-large-bikes?utm_source=ridesizer&h=${this.bike.height}&c=${this.bike.color}`;
            }
        } else if (Number(this.bike.wheel) === 24) {
            // 24-inches white bike is an exception for now (it sales on Amazon)
            if (this.bike.color === 'white') {
                shopURL = 'https://www.amazon.com/dp/B06XHF93M7/ref=twister_B07KMZ7ZKJ?_encoding=UTF8&psc=1'
            } else {
                shopURL += `24-inch-bikes?utm_source=ridesizer&h=${this.bike.height}&c=${this.bike.color}`
            }
        } else if (Number(this.bike.wheel) === 16){
            shopURL += `16-inch-bikes?utm_source=ridesizer&h=${this.bike.height}&c=${this.bike.color}`;
        } else {
            shopURL = baseURL
        }

        // Includes Partners options in request
        if (params.hasOwnProperty('partnerKey')) {
            shopURL += `?${params.partnerKey}=${params.partnerValue}`;
            if (Number(this.bike.wheel) === 24 && this.bike.color === 'white') {
                shopURL = 'https://amzn.to/2QYiBM8'
            }
        }

        return shopURL;
    }

}


// WEBPACK FOOTER //
// ./src/classes/Shop.js